import { faqs } from "@/mocks/videoData";
import { useState } from "react";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 mt-2">关于苹果视频，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm font-medium text-foreground-950 pr-4">
                  {faq.question}
                </h3>
                <span className={`w-6 h-6 flex items-center justify-center rounded-full transition-colors flex-shrink-0 ${
                  openIndex === index
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-200 text-foreground-600"
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${
                    openIndex === index ? "ri-subtract-line" : "ri-add-line"
                  }`}></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-48 pb-4 px-5" : "max-h-0"
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}